import axios, { AxiosInstance } from 'axios';

class BaseService {
  private axios: AxiosInstance;

  constructor() {
    this.axios = axios;
  }

  get(url) {
    return this.axios.get(url);
  }

  post(url, data) {
    return this.axios.post(url, data);
  }

  put(url, data) {
    return this.axios.put(url, data);
  }

  delete(url) {
    return this.axios.delete(url);
  }
}

export default BaseService;
